import { ROUTES } from '../lib/routes';
import { navigate } from '../router';
import { el } from '../utils/dom';

export function renderHomePage(root: HTMLElement): void {
  root.append(
    sectionPortalHero(),
    sectionHomeTrustStats(),
    sectionCoreServices(),
    sectionInstallTypes(),
    sectionHomeCtaGrid()
  );
}

function sectionPortalHero(): HTMLElement {
  const sec = el('section', { className: 'ev123-portal-hero ev123-portal-hero--pro' });
  const inner = el('div', { className: 'ev123-container ev123-portal-hero__grid' });

  const left = el('div', {});
  const heroTitle = el('h1', { className: 'ev123-portal-title' });
  heroTitle.append(
    document.createTextNode('전기차충전기 설치가 필요할 때,'),
    el('br', {}),
    document.createTextNode('신규설치·교체설치·이전설치까지 한 번에 확인하세요')
  );
  left.append(
    el('p', { className: 'ev123-portal-eyebrow', text: 'EV123 · 전기차충전기 설치 판단 포털' }),
    heroTitle,
    el('p', {
      className: 'ev123-portal-lead',
      text: '공동주택, 상업시설, 업무시설, 공공시설의 전기차충전기 설치 가능 여부와 적정 대수를 빠르게 검토해보세요.',
    }),
    el('div', { className: 'ev123-portal-actions' }, [
      (() => {
        const b = btnPrimary('충전기 설치 계산 시작', () => navigate(ROUTES.newInstall));
        b.classList.add('ev123-btn--pill');
        return b;
      })(),
      (() => {
        const b = btnSecondary('설치 상담 신청', () => navigate(ROUTES.consult));
        b.classList.add('ev123-btn--pill');
        return b;
      })(),
    ])
  );

  const panel = el('div', { className: 'ev123-portal-panel' });
  panel.append(
    el('h2', { className: 'ev123-portal-panel__title', text: '바로가기' }),
    el('p', {
      className: 'ev123-portal-panel__lead',
      text: '설치 가능 여부, 대수, 방식, 법령·자료, 사례, 상담까지 한 화면에서 이어집니다.',
    }),
    el('div', { className: 'ev123-quick-menu' }, [
      quickItem('설치 기준', '주차면·시설 유형으로 검토 기준을 확인합니다.', () => navigate(ROUTES.newInstall)),
      quickItem('설치 상담', '신규·추가·교체·이전·운영 상담을 신청합니다.', () => navigate(ROUTES.consult)),
      quickItem('설치사례', '건물 유형별 설치사례를 확인합니다.', () => navigate(ROUTES.installCaseBoard)),
      quickItem('자료실', '공지·법령·업무자료·뉴스를 확인합니다.', () => navigate(ROUTES.resources)),
      quickItem('차별화서비스', 'EVOS TEAM 설치·운영 컨설팅을 확인합니다.', () => navigate(ROUTES.differentiatedServices)),
    ])
  );

  inner.append(left, panel);
  sec.appendChild(inner);
  return sec;
}

function sectionHomeTrustStats(): HTMLElement {
  const sec = el('section', { className: 'ev123-section ev123-section--tight ev123-home-trust-stats' });
  const inner = el('div', { className: 'ev123-container' });
  const grid = el('div', { className: 'ev123-home-trust-stats__grid' });
  const items: [string, string, string][] = [
    ['벤처기업', '기술 기반 전기차충전 인프라 서비스 기업', 'trust-1'],
    ['8개 시도회 업무제휴', '주택관리사협회 시도회 네트워크 기반', 'trust-2'],
    ['약 1,000개소 설치 경험', '전기차충전기 설치 건물 경험', 'trust-3'],
    ['약 18,000개 DB', '공동주택·관리사무소 데이터 기반', 'trust-4'],
  ];
  for (const [value, label, trustKey] of items) {
    const c = el('div', { className: 'ev123-home-trust-stats__cell' });
    c.append(
      el('span', {
        className: `ev123-badge ev123-badge--${trustKey}`,
        text: trustKey === 'trust-1' ? '기업' : trustKey === 'trust-2' ? '협력' : trustKey === 'trust-3' ? '현장' : '데이터',
      }),
      el('p', { className: 'ev123-home-trust-stats__value', text: value }),
      el('p', { className: 'ev123-home-trust-stats__label', text: label })
    );
    grid.appendChild(c);
  }
  inner.appendChild(grid);
  sec.appendChild(inner);
  return sec;
}

function quickItem(title: string, desc: string, onClick: () => void): HTMLButtonElement {
  const row = el('button', { type: 'button', className: 'ev123-quick-item' }) as HTMLButtonElement;
  const t = el('span', {});
  t.append(el('b', { text: title }), el('span', { text: desc }));
  row.appendChild(t);
  row.addEventListener('click', onClick);
  return row;
}

function sectionCoreServices(): HTMLElement {
  const sec = el('section', { className: 'ev123-section ev123-section--relaxed ev123-section--band' });
  const inner = el('div', { className: 'ev123-container' });
  inner.append(
    el('div', { className: 'ev123-section-head ev123-section-head--center' }, [
      el('h2', { className: 'ev123-section__title ev123-section__title--home', text: '주요 서비스' }),
      el('p', {
        className: 'ev123-section__lead ev123-section__lead--home',
        text: '대수 계산부터 상담·사례·자료까지 단계적으로 이용하실 수 있습니다.',
      }),
    ])
  );
  const grid = el('div', { className: 'ev123-grid ev123-grid--4 ev123-grid--platform' });
  grid.append(
    coreCard({
      title: '설치 가능 대수 계산',
      desc: '시설 유형과 주차면을 입력해 가능 대수와 기준을 확인합니다.',
      action: () => navigate(ROUTES.newInstall),
      label: '계산 시작',
      primaryStyle: true,
    }),
    coreCard({
      title: '설치 상담',
      desc: '신규·추가·교체·이전·운영 상담을 접수합니다.',
      action: () => navigate(ROUTES.consult),
      label: '상담 신청',
      primaryStyle: false,
    }),
    coreCard({
      title: '설치사례',
      desc: '건물 유형별 전기차충전기 설치사례를 확인합니다.',
      action: () => navigate(ROUTES.installCaseBoard),
      label: '사례 보기',
      primaryStyle: false,
    }),
    coreCard({
      title: '자료실',
      desc: '공지·법령·업무자료·뉴스를 한곳에서 확인합니다.',
      action: () => navigate(ROUTES.resources),
      label: '자료실 열기',
      primaryStyle: false,
    })
  );
  inner.appendChild(grid);
  sec.appendChild(inner);
  return sec;
}

function sectionInstallTypes(): HTMLElement {
  const sec = el('section', { className: 'ev123-section ev123-section--tight ev123-section--surface' });
  const inner = el('div', { className: 'ev123-container' });
  inner.append(
    el('div', { className: 'ev123-section-head ev123-section-head--center' }, [
      el('h2', { className: 'ev123-section__title ev123-section__title--home', text: '설치 유형 안내' }),
      el('p', {
        className: 'ev123-section__lead ev123-section__lead--home',
        text: '건물 조건에 맞는 설치 유형을 먼저 구분해 보세요.',
      }),
    ])
  );
  const grid = el('div', { className: 'ev123-home-type-grid' });
  const types: { title: string; desc: string; route: (typeof ROUTES)[keyof typeof ROUTES] }[] = [
    { title: '신규설치', desc: '최초로 충전시설을 도입하는 경우입니다.', route: ROUTES.newInstall },
    { title: '교체설치', desc: '노후 충전기를 교체·개선하는 경우입니다.', route: ROUTES.newInstall },
    { title: '이전설치', desc: '충전구역을 옮기거나 재배치하는 경우입니다.', route: ROUTES.consult },
    { title: '수익형 충전기', desc: '운영·수익 모델을 함께 검토하는 경우입니다.', route: ROUTES.consult },
  ];
  for (const t of types) {
    const card = el('article', { className: 'ev123-card ev123-home-type-card' });
    const btn = el('button', {
      type: 'button',
      className: 'ev123-btn ev123-btn--secondary ev123-btn--pill ev123-btn--sm',
    }) as HTMLButtonElement;
    btn.textContent = '검토하기';
    btn.addEventListener('click', () => navigate(t.route));
    card.append(
      el('h3', { className: 'ev123-home-type-card__title', text: t.title }),
      el('p', { className: 'ev123-home-type-card__desc', text: t.desc }),
      btn
    );
    grid.appendChild(card);
  }
  inner.appendChild(grid);
  sec.appendChild(inner);
  return sec;
}

function sectionHomeCtaGrid(): HTMLElement {
  const sec = el('section', { className: 'ev123-section ev123-section--tight ev123-section--band ev123-home-cta-section' });
  const inner = el('div', { className: 'ev123-container' });
  inner.append(
    el('div', { className: 'ev123-section-head ev123-section-head--center' }, [
      el('h2', {
        className: 'ev123-section__title ev123-section__title--home',
        text: '바로 시작하기',
      }),
    ])
  );
  const grid = el('div', { className: 'ev123-home-cta-grid' });
  grid.append(
    homeCtaCard(
      '설치 가능 대수 확인',
      '시설 정보를 입력해 설치 기준과 가능 대수를 확인합니다.',
      '충전기 설치 계산',
      true,
      () => navigate(ROUTES.newInstall)
    ),
    homeCtaCard(
      '설치 상담 신청',
      '현장 조건과 운영방식을 함께 검토해드립니다.',
      '상담 신청하기',
      false,
      () => navigate(ROUTES.consult)
    ),
    homeCtaCard(
      '설치사례 보기',
      '건물 유형별 전기차충전기 설치사례를 확인합니다.',
      '사례 보드 열기',
      false,
      () => navigate(ROUTES.installCaseBoard)
    )
  );
  inner.appendChild(grid);
  sec.appendChild(inner);
  return sec;
}

function homeCtaCard(
  title: string,
  desc: string,
  btnLabel: string,
  primary: boolean,
  action: () => void
): HTMLElement {
  const card = el('article', { className: 'ev123-card ev123-home-cta-card' });
  const btn = el('button', {
    type: 'button',
    className: primary
      ? 'ev123-btn ev123-btn--primary ev123-btn--block ev123-btn--pill'
      : 'ev123-btn ev123-btn--secondary ev123-btn--block ev123-btn--pill',
  }) as HTMLButtonElement;
  btn.textContent = btnLabel;
  btn.addEventListener('click', action);
  const actions = el('div', { className: 'ev123-home-cta-card__actions' });
  actions.appendChild(btn);
  card.append(
    el('h3', { className: 'ev123-home-cta-card__title', text: title }),
    el('p', { className: 'ev123-home-cta-card__desc', text: desc }),
    actions
  );
  return card;
}

function coreCard(opts: {
  title: string;
  desc: string;
  action: () => void;
  label: string;
  primaryStyle: boolean;
}): HTMLElement {
  const card = el('div', { className: 'ev123-card ev123-service-card ev123-card--platform ev123-card--elevated' });
  const head = el('div', { className: 'ev123-card__platform-head' });
  head.appendChild(el('h3', { className: 'ev123-card__platform-title', text: opts.title }));
  const body = el('div', { className: 'ev123-card__platform-body ev123-card__platform-body--service' });
  body.appendChild(el('p', { className: 'ev123-card__platform-desc', text: opts.desc }));
  const btn = el('button', {
    type: 'button',
    className: opts.primaryStyle
      ? 'ev123-btn ev123-btn--primary ev123-btn--block ev123-btn--pill'
      : 'ev123-btn ev123-btn--secondary ev123-btn--block ev123-btn--pill',
  }) as HTMLButtonElement;
  btn.textContent = opts.label;
  btn.addEventListener('click', opts.action);
  body.appendChild(btn);
  card.append(head, body);
  return card;
}

function btnPrimary(label: string, onClick: () => void): HTMLButtonElement {
  const b = el('button', { type: 'button', className: 'ev123-btn ev123-btn--primary' }) as HTMLButtonElement;
  b.textContent = label;
  b.addEventListener('click', onClick);
  return b;
}

function btnSecondary(label: string, onClick: () => void): HTMLButtonElement {
  const b = el('button', { type: 'button', className: 'ev123-btn ev123-btn--secondary' }) as HTMLButtonElement;
  b.textContent = label;
  b.addEventListener('click', onClick);
  return b;
}
